import { useLocale } from "../providers/LocaleProvider";

export interface WarningsPanelProps {
  /** List of warning messages from the conversion result */
  warnings: string[];
}

/**
 * Warnings panel displaying conversion warnings.
 * Only rendered when there are warnings to show.
 */
export function WarningsPanel({ warnings }: WarningsPanelProps) {
  const { t } = useLocale();

  if (warnings.length === 0) {
    return null;
  }

  return (
    <section className="warnings-panel">
      <h2>{t("warnings.title")}</h2>
      <ul>
        {warnings.map((warning) => (
          <li key={warning}>{warning}</li>
        ))}
      </ul>
    </section>
  );
}
